// store.js

import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer } from "redux-persist"; // imports from redux-persist
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import thunk from "redux-thunk";
import Cookie from "js-cookie";

import rootReducer from "./reducers";

const persistConfig = {
  // configuration object for redux-persist
  key: "root",
  storage, // define which storage to use,
  blacklist: ['Assets']
};
const storeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistedReducer = persistReducer(persistConfig, rootReducer); // create a persisted reducer

const store = createStore(
  persistedReducer, // pass the persisted reducer instead of rootReducer to createStore
  storeEnhancers(applyMiddleware(thunk)) // add any middlewares here
);

const persistor = persistStore(store); // used to create the persisted store, persistor will be used in the next step

export { store, persistor };
